var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { AzureCommunicationTokenCredential, } from "@azure/communication-common";
import { CallComposite, useTeamsCallAdapter, } from "@azure/communication-react";
import { initializeIcons } from "@fluentui/react";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
// import { validate as validateUUID } from "uuid";
initializeIcons();
const isTeamsMeetingLink = (link) => link.startsWith("https://teams.microsoft.com/l/meetup-join");
// const isGroupID = (id: string): boolean => validateUUID(id);
const createCallAdapterLocator = (locator) => {
    //   if (isTeamsMeetingLink(locator)) {
    return { meetingLink: locator };
    //   }
    //   } else if (isGroupID(locator)) {
    //     return { groupId: locator };
    //   } else if (/^\d+$/.test(locator)) {
    //     return { roomId: locator };
    //   }
    return undefined;
};
export const TeamsMeetingManager = (props) => {
    const { onMeetingEnd } = props;
    console.log({ props });
    const credential = useMemo(() => {
        try {
            return new AzureCommunicationTokenCredential(props.token);
        }
        catch (_a) {
            console.error("Failed to construct token credential");
            return undefined;
        }
    }, [props.token]);
    // Profile fetch callback for Teams adapter
    const onFetchProfile = useCallback((userId, defaultProfile) => __awaiter(void 0, void 0, void 0, function* () {
        if (defaultProfile === null || defaultProfile === void 0 ? void 0 : defaultProfile.displayName) {
            return defaultProfile;
        }
        return { displayName: props.displayName };
    }), [props.displayName]);
    const options = useMemo(() => ({
        onFetchProfile,
    }), [onFetchProfile]);
    // CRITICAL: Use useTeamsCallAdapter for Teams meetings (not useAzureCommunicationCallAdapter)
    // This is specifically designed for Teams users and accepts MicrosoftTeamsUserIdentifier
    // For Teams adapter, locator should be meetingLink format
    const teamsCallAdapterArgs = useMemo(() => ({
        userId: props.userId,
        credential,
        locator: props.locator
            ? {
                meetingLink: props.locator,
            }
            : undefined,
        options,
    }), [props.userId, credential, props.locator, options]);
    const adapter = useTeamsCallAdapter(teamsCallAdapterArgs, undefined, leaveCall);
    const hasLoggedEndRef = useRef(false);
    useEffect(() => {
        if (!adapter)
            return;
        const endedPages = [
            "leftCall",
            "leaving",
            "removedFromCall",
        ];
        const handleStateChange = (state) => {
            if (!hasLoggedEndRef.current && endedPages.includes(state.page)) {
                hasLoggedEndRef.current = true;
                console.log("[TeamsMeetingCandidate] Meeting ended");
                onMeetingEnd === null || onMeetingEnd === void 0 ? void 0 : onMeetingEnd();
            }
            else if (state.page === "call") {
                hasLoggedEndRef.current = false;
            }
        };
        adapter.onStateChange(handleStateChange);
        return () => {
            adapter.offStateChange(handleStateChange);
        };
    }, [adapter, onMeetingEnd]);
    if (!props.locator) {
        return _jsxs(_Fragment, { children: ["Provided call locator '", props.locator, "' is not recognized."] });
    }
    if (adapter) {
        return (_jsx("div", Object.assign({ style: { height: "calc(100vh - 64px)", width: "100vw" } }, { children: _jsx(CallComposite, { adapter: adapter, formFactor: props.formFactor, 
                //   fluentTheme={props.fluentTheme}
                rtl: props.rtl, callInvitationUrl: props === null || props === void 0 ? void 0 : props.callInvitationURL, locale: props === null || props === void 0 ? void 0 : props.locale, options: props === null || props === void 0 ? void 0 : props.options }) })));
    }
    if (credential === undefined) {
        return _jsx(_Fragment, { children: "Failed to construct credential. Provided token is malformed." });
    }
    return _jsx(_Fragment, { children: "Initializing..." });
};
const leaveCall = (adapter) => __awaiter(void 0, void 0, void 0, function* () {
    yield adapter.leaveCall().catch((e) => {
        console.error("Failed to leave call", e);
    });
});
export const TeamsMeeting = TeamsMeetingManager;
